// components/PlatformBanner.js
// Shows the platform-wide announcement and this school's subscription-expiry warning,
// both configured by the platform super-admin.
import React, { useEffect, useState } from 'react';
import { Alert, Collapse, Box } from '@mui/material';
import axios from 'axios';

const STATUS_URL = `${process.env.REACT_APP_API_BASE_URL}/api/superadmin/status/`;
const DISMISS_KEY = 'dismissedAnnouncement';

const readDismissed = () => {
  try { return sessionStorage.getItem(DISMISS_KEY); } catch { return null; }
};

const PlatformBanner = () => {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    axios
      .get(STATUS_URL, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((res) => setStatus(res.data))
      .catch(() => {});
  }, []);

  if (!status) return null;

  const { announcement, subscription_days_left: daysLeft } = status;
  const isManager = localStorage.getItem('role') === 'manager';
  const showAnnouncement = announcement && dismissed !== announcement.text;

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, announcement.text); } catch { /* ignore */ }
    setDismissed(announcement.text);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: (showAnnouncement || (isManager && daysLeft !== null)) ? 2 : 0 }}>
      <Collapse in={!!showAnnouncement} unmountOnExit>
        {announcement && (
          <Alert severity={announcement.level} onClose={dismiss} sx={{ direction: 'rtl', fontFamily: 'Cairo, Tajawal, sans-serif', whiteSpace: 'pre-line' }}>
            {announcement.text}
          </Alert>
        )}
      </Collapse>
      {isManager && daysLeft !== null && (
        <Alert severity={daysLeft <= 3 ? 'error' : 'warning'} sx={{ direction: 'rtl', fontFamily: 'Cairo, Tajawal, sans-serif' }}>
          {daysLeft <= 0
            ? 'ينتهي اشتراك المدرسة اليوم. يرجى التواصل مع إدارة المنصة للتجديد.'
            : `سينتهي اشتراك المدرسة خلال ${daysLeft} يوم. يرجى التواصل مع إدارة المنصة للتجديد.`}
        </Alert>
      )}
    </Box>
  );
};

export default PlatformBanner;
